import {
  AppInsightsContext,
  ReactPlugin,
} from '@microsoft/applicationinsights-react-js';
import {
  ApplicationInsights,
  DistributedTracingModes,
} from '@microsoft/applicationinsights-web';
import React, { useMemo } from 'react';

import { AppInsightsInstanceContext } from './contexts/app-insights-instance-context';

export const AppInsightsProvider: React.FC = ({ children }) => {
  const reactPlugin = useMemo<ReactPlugin>(() => new ReactPlugin(), []);

  const appInsights = useMemo(() => {
    const connectionString =
      process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;
    if (!connectionString) {
      console.log('Application Insights not configured.');
      return;
    }

    const appInsights = new ApplicationInsights({
      config: {
        connectionString,
        autoTrackPageVisitTime: true,
        enableAutoRouteTracking: true,
        distributedTracingMode: DistributedTracingModes.W3C,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        enableUnhandledPromiseRejectionTracking: true,
        extensions: [reactPlugin],
      },
    });

    appInsights.loadAppInsights();

    return appInsights;
  }, [reactPlugin]);

  return (
    <AppInsightsInstanceContext.Provider value={appInsights}>
      <AppInsightsContext.Provider value={reactPlugin}>
        {children}
      </AppInsightsContext.Provider>
    </AppInsightsInstanceContext.Provider>
  );
};
